import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IAccount } from '../../hub-lo.component';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';
import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';

@Component({
  selector: 'hub-lo-authorization-intro-step',
  templateUrl: 'authorization-intro-step.component.html',
  styleUrls: ['authorization-intro-step.component.scss'],
})
export class HubLoAuthorizationIntroStepComponent implements OnInit, OnChanges {
  @Input() public accounts: IAccount[] = [];
  @Input() public consentChecked: boolean = false;
  @Input() public origin: 'Home' | 'Dados bancários' = 'Home';

  @Output() public selectAccount = new EventEmitter<number>();
  @Output() public consentChange = new EventEmitter<boolean>();
  @Output() public stepButton = new EventEmitter<void>();

  public termsForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private store: Store<AppState>,
  ) {
    this.termsForm = this.formBuilder.group({
      agree: [false, Validators.required],
    });
  }

  public ngOnInit(): void {
    this.syncConsentState();
    this.store.dispatch({
      type: TrackingActions.trackEvents,
      payload: {
        type: ActionEventsEnum.PAGE_LOADED,
        events: {
          'Product Area Origin': this.origin,
          Scenario: 'Possui uma conta cadastrada',
          Step: 'Autorizar comunicação entre contas',
          'Time Responsável': 'Sky',
        },
      },
    });

    this.termsForm
      .get('agree')
      ?.valueChanges.subscribe((checked: boolean | null) => {
        this.consentChange.emit(!!checked);
      });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.consentChecked) {
      this.syncConsentState();
    }
  }

  private syncConsentState(): void {
    this.termsForm
      .get('agree')
      .setValue(this.consentChecked, { emitEvent: false });
  }

  public isStepButtonDisabled(): boolean {
    if (this.accounts.length === 1) {
      return !this.consentChecked;
    }
    return false;
  }

  public onContinueClick(): void {
    if (this.accounts.length === 1) {
      this.store.dispatch({
        type: TrackingActions.trackEvents,
        payload: {
          type: ActionEventsEnum.ELEMENT_CLICKED,
          events: {
            'Product Area Origin': this.origin,
            Element: 'Botão autorizar',
            Step: 'Autorizar comunicação entre contas',
            Scenario: 'Possui uma conta cadastrada',
            Status: 'Cliente Santander',
            'Time Responsável': 'Sky',
          },
        },
      });
    }
    this.stepButton.emit();
  }
}
